import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=360ecec2&scoped=true&"
import script from "./Proposal.vue?vue&type=script&lang=js&"
export * from "./Proposal.vue?vue&type=script&lang=js&"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=360ecec2&prod&lang=css&"
import style1 from "./Proposal.vue?vue&type=style&index=1&id=360ecec2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360ecec2",
  null
  
)

export default component.exports